import React, { createContext, useContext, useReducer, useState } from "react";
import { reducer, initialState } from "./imagesReducer";

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [defaultModal, setDefaultModal] = useState("");
  const [shareMode, setShareMode] = useState("");
  const [createNewPaletteModal, setCreateNewPaletteModal] = useState(false);
  const [loadingColorMatch, setLoadingColorMatch] = useState(null);
  const [hexaColormatch, setHexaColormatch] = useState([]);

  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
        user,
        setUser,
        loading,
        setLoading,
        defaultModal,
        setDefaultModal,
        shareMode,
        setShareMode,
        createNewPaletteModal,
        setCreateNewPaletteModal,
        loadingColorMatch,
        setLoadingColorMatch,
        hexaColormatch,
        setHexaColormatch,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
